import React, { useState } from "react";

// Styles
import styles from "./BottomDrawer.module.css";

// MUI Components
import { Box, TextField } from "@mui/material";

const BottomDrawer = (props) => {
  // Props destructuring
  const {
    searchQuery,
    examType,
    totalQuestion,
    totalTime,
    marksCorrectAnswer,
    marksIncorrectAnswer,
    marksNotAttempted,
    setTotalQuestion,
    setTotalTime,
    handleSelftTestOption,
    selftTestOptions,
    selftTestOptionIndex,
    setMarksCorrectAnswer,
    setMarksIncorrectAnswer,
    setMarksNotAttempted,
    organisationName,
    availableTotalQuestion,
    upgradeNow,
    startMyTest,
    validityExpired,
    progressBar,
    progressBarFlag,
    progressBarRemarks,
    selfAssessorFormType,
  } = props;

  // States
  const [isExpanded, setIsExpanded] = useState(false);

  // Utility Function
  // Function to toggle the bottom nav
  const setBottomNavStatus = () => {
    setIsExpanded(!isExpanded);
  };

  const handleLearningMode = (val) => {
    localStorage.setItem("selfAssessorFormType", val);
    props.prntSelfAssessorFormType(val);
  };

  return (
    <div className={styles.bottom_drawer}>
      {/* Condition to check if the bottom nav is expanded or not */}
      {!isExpanded ? ( // Minimized view
        <div onClick={setBottomNavStatus} className={styles.bottom_min_mode}>
          {/* Arrow Animation */}
          <div className={styles.bottom_arrow}>
            <img
              src={process.env.PUBLIC_URL+"/arrow-up.svg"}
              className={styles.bottom_arrow_svg}
              alt="ETL arrow"
            />
          </div>

          {/* Text Content */}
          <div className={styles.bottom_main_content}>
            <p>{searchQuery}</p>
            <h3>{progressBar}%</h3>
            <span>
              {progressBar === 0 ? "Begin learning to track progress" : ""}
            </span>
          </div>

          {/* Progress Bar */}
          {progressBarFlag && progressBarFlag > 0 ? (
            <div className={styles.bottom_loader}>
              <div className={styles.bottom_loader_container}>
                <div
                  className={styles.bottom_loader_progress}
                  style={{
                    width: `${progressBar}%`,
                    backgroundColor:
                      progressBar < 33
                        ? "#ff3c3c"
                        : progressBar < 66 && progressBar >= 33
                        ? "#f09766"
                        : progressBar < 85 && progressBar >= 66
                        ? "#f4d532"
                        : progressBar >= 85
                        ? "#38bb25"
                        : "#f09766",
                  }}
                ></div>
              </div>
              <span>{progressBarRemarks}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        // Expanded View
        <div className={styles.bottom_expanded}>
          {/* Down Arrow */}
          <div
            onClick={() => {
              setIsExpanded(false);
            }}
            className={styles.bottom_arrow_down}
          >
            <img
              src={process.env.PUBLIC_URL+"/arrow-up.svg"}
              className={styles.bottom_arrow_svg_down}
              alt="ETL arrow"
            />
          </div>
          {/* Main Text Content */}
          <div className={styles.bottom_main_content}>
            <p>{searchQuery}</p>
              <>
                    {selftTestOptions && selftTestOptions.length > 1 ? (
                      <TextField
                        
                        id="outlined-select-native"
                        select
                        label="Assessment Type"
                        value={selftTestOptionIndex}
                        onChange={(event) => {
                          handleSelftTestOption(event.target.value);
                        }}
                        SelectProps={{
                          native: true,
                        }}
                        size="small"
                        style={{ fontSize: 12, width:'96%' }}
                      >
                        {selftTestOptions.map((row, i) => (
                          <option key={"a" + i} value={i}>
                            {row.examType}
                          </option>
                        ))}
                      </TextField>
                    ) : null}
              </>

            <div className={styles.bottom_button_toggle}>
              <div className={styles.bottom_toggle_container}>
                <p
                  onClick={() => {handleLearningMode("beginner")}}
                  className={`${
                    selfAssessorFormType === "beginner"
                      ? styles.bottom_toggle_container_selected
                      : ""
                  }`}
                >
                  Learning Mode
                </p>
                <p
                  onClick={() => {handleLearningMode("advance")}}
                  className={`${
                    selfAssessorFormType === "advance"
                      ? styles.bottom_toggle_container_selected
                      : ""
                  }`}
                >
                  Competitive Mode
                </p>
              </div>
            </div>
            <h3>{progressBar}%</h3>
            <span>
              {progressBar === 0 ? "Begin learning to track progress" : ""}
            </span>

            {/* Progress Bar */}
            {progressBarFlag && progressBarFlag > 0 ? (
              <div className={styles.bottom_loader}>
                <div className={styles.bottom_loader_container}>
                <div
                  className={styles.bottom_loader_progress}
                  style={{
                    width: `${progressBar}%`,
                    backgroundColor:
                      progressBar < 33
                        ? "#ff3c3c"
                        : progressBar < 66 && progressBar >= 33
                        ? "#f09766"
                        : progressBar < 85 && progressBar >= 66
                        ? "#f4d532"
                        : progressBar >= 85
                        ? "#38bb25"
                        : "#f09766",
                  }}
                ></div>
                </div>
                <span>{progressBarRemarks}</span>
              </div>
            ) : (
              <></>
            )}
          </div>

          {/* Instructions Table */}
          <div className={styles.bottom_instructions}>
            {selfAssessorFormType === "beginner" ? (
              <div className={styles.bottom_instructions_heading}>
                <p>General Instructions</p>
              </div>
            ) : (
              <></>
            )}
            <div className={styles.bottom_instructions_content}>
              {selfAssessorFormType === "beginner" ? (
                <ul style={{ marginLeft: 12 }}>
                  <li>Try to answer all the questions.</li>
                  <li>
                    <span style={{ color: "red" }}>Do not guess.</span> In case
                    you don't know the answer click{" "}
                    <span style={{ color: "green" }}>HELP</span>
                  </li>
                  <li>
                    First search the answer from your books. Then ask Tony AI
                  </li>
                  <li>
                    If your doubts are still not cleared SKIP the question. ETL
                    Teachers will clear the doubts.
                  </li>
                  <li>
                    Each learning session will have different set questions.
                  </li>
                  <li>
                    We recommend to move to competitive mode only if the
                    learning session progress bar is green.
                  </li>
                </ul>
              ) : (
                <>
                  {/* <Box className="btmbdrgry"> */}
                  {/* </Box> */}
                  <Box component="form" noValidate>
                    <TextField
                      onChange={(event) => setTotalQuestion(event.target.value)}
                      value={totalQuestion}
                      style={{ width: "45%", marginTop: 15, marginRight: "4%" }}
                      type="number"
                      min="10"
                      max="30"
                      label="Total number of question"
                      variant="standard"
                    />
                    <TextField
                      onChange={(event) => setTotalTime(event.target.value)}
                      value={totalTime}
                      style={{ width: "45%", marginTop: 15, marginRight: "4%" }}
                      type="number"
                      defaultValue="30"
                      min="5"
                      max="30"
                      label="Total time for Test (minute)"
                      variant="standard"
                    />
                    <TextField
                      onChange={(event) =>
                        setMarksCorrectAnswer(event.target.value)
                      }
                      value={marksCorrectAnswer}
                      style={{ width: "45%", marginTop: 15, marginRight: "4%" }}
                      type="number"
                      defaultValue="1"
                      min="1"
                      max="50"
                      step="0.1"
                      label="Marks for correct answer"
                      variant="standard"
                    />
                    {examType && examType === "objective" ? (
                      <>
                        <TextField
                          onChange={(event) =>
                            setMarksIncorrectAnswer(event.target.value)
                          }
                          value={marksIncorrectAnswer}
                          style={{
                            width: "45%",
                            marginTop: 15,
                            marginRight: "4%",
                          }}
                          type="number"
                          defaultValue="0"
                          min="0"
                          max="50"
                          step="0.1"
                          label="Marks for incorrect answer"
                          variant="standard"
                        />
                        <TextField
                          onChange={(event) =>
                            setMarksNotAttempted(event.target.value)
                          }
                          value={marksNotAttempted}
                          style={{
                            width: "45%",
                            marginTop: 15,
                            marginRight: "4%",
                          }}
                          type="number"
                          defaultValue="0"
                          min="0"
                          max="50"
                          step="0.1"
                          label="Marks for questions not attempted"
                          variant="standard"
                        />
                      </>
                    ) : null}
                  </Box>
                </>
              )}

              {validityExpired === true ? (
                <Box mt={2}>
                  <h4
                    style={{
                      textAlign: "center",
                      color: "#FF0000",
                      fontWeight: "bold",
                    }}
                  >
                    {organisationName && organisationName.length > 0 ? (
                      <>{organisationName}'s</>
                    ) : null}{" "}
                    validity has been finished. Renew your account to continue
                    your practice.
                  </h4>
                </Box>
              ) : null}

              <div className={styles.bottom_content_buttons}>
                <div
                  onClick={() => {
                    setIsExpanded(false);
                  }}
                >
                  <span>Go Back</span>
                </div>
                {availableTotalQuestion != null &&
                availableTotalQuestion > 0 ? (
                  <div
                    onClick={() => {
                      if (validityExpired) {
                        upgradeNow();
                      } else {
                        startMyTest();
                      }
                    }}
                  >
                    <span>{validityExpired ? "Renew Now" : "Start"}</span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomDrawer;
